import { Component } from '@angular/core';

@Component({
    selector: 'sc-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

    public title = 'editing-tool';

    constructor() { }
}
